import http from '@/utils/http';
import request from '@/utils/request';

export function login(userInfo) {
  const params = new URLSearchParams();
  params.append('username',userInfo.username);
  params.append('password',userInfo.password);
  params.append('client_id','ro.client');
  params.append('client_secret','secret');
  params.append('scopes','apibase offline_access');
  params.append('grant_type','password');
  return http('/connect/token', {   // /api/token/create
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    method: 'post',
    // params: {
    //   useRefreshToken: true
    // },
    data: params
  });
}

export function getInfo(token) {
  return http('/api/ManagePanel/ManageUserInfo', {
    method: 'get'
  });
}
// export function getSidebarMenu() {
//   return http(window.sidebarapi + '/static/module.json', {
//     method: 'get'
//   });
// }
export function getSidebarMenu() {
    return http('/api/RoleApi/GetMenus', {
      method: 'get'
    });
}
export function getSidebarMenu_S() {
  return http(window.sidebarapi + '/static/shoppers.json', {
    method: 'get'
  });
}

export function refreshToken(token, refreshToken) {
  // 刷新token不使用封装的http方法，绕过过期检查
  const params = new URLSearchParams();
  params.append('client_id','ro.client');
  params.append('client_secret','secret');
  params.append('scopes','apibase offline_access');
  params.append('grant_type','refresh_token');
  params.append('refresh_token',refreshToken);
  return request({
    url: '/connect/token',
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: params
    // data: {
    //   token: token,
    //   refreshToken: refreshToken
    // }

  });
}

export function checkPsd(password) {
  const form = new FormData();
  form.append('password', password);
  return http('/api/ManageApi/VerifyPassword', {
    method: 'post',
    data: form
  });
}

export function changePsd(form) {
  return http('/api/ManageApi/ChangePassword', {
    method: 'post',
    data: form
  });
}

export function dashboard() {
  return http('/api/SidebarMenuApi/Dashboard', {
    method: 'get'
  });
}


// WEBPACK FOOTER //
// ./src/api/login.js